import React, { FC } from 'react';
import {
	CheckOutlined,
	ClockCircleOutlined,
	CloseCircleOutlined,
	EditOutlined,
	HourglassOutlined,
} from '@ant-design/icons';
import {
	COMPLIANCE_INSTANCE_STATUSES,
	COMPLIANCE_REQUEST_LIFECYCLES,
} from '../../types/ComplianceTypes';
import {
	COMPLIANCE_INSTANCE_STATUS_COLORS,
	COMPLIANCE_INSTANCE_STATUS_DISPLAY_NAMES_BUYER,
	COMPLIANCE_INSTANCE_STATUS_DISPLAY_NAMES_SUPPLIER,
} from './ComplianceConstants';

const STATUS_ICONS = {
	[COMPLIANCE_REQUEST_LIFECYCLES.DRAFT]: EditOutlined,
	[COMPLIANCE_INSTANCE_STATUSES.WAITING_ON_SUPPLIER]: HourglassOutlined,
	[COMPLIANCE_INSTANCE_STATUSES.PENDING_REVIEW]: ClockCircleOutlined,
	[COMPLIANCE_INSTANCE_STATUSES.APPROVED]: CheckOutlined,
	[COMPLIANCE_INSTANCE_STATUSES.REJECTED]: CloseCircleOutlined,
};

interface ComplianceStatusDisplayProps {
	status: string;
	// 'buyer' shows "Waiting on Supplier"; 'supplier' shows "Requested".
	perspective?: 'buyer' | 'supplier';
	className?: string;
}

export const ComplianceStatusDisplay: FC<ComplianceStatusDisplayProps> = ({
	status,
	perspective = 'buyer',
	className = '',
}): React.ReactElement => {
	const displayNames =
		perspective === 'supplier'
			? COMPLIANCE_INSTANCE_STATUS_DISPLAY_NAMES_SUPPLIER
			: COMPLIANCE_INSTANCE_STATUS_DISPLAY_NAMES_BUYER;
	const color = COMPLIANCE_INSTANCE_STATUS_COLORS[status] || 'inherit';
	const IconComponent = STATUS_ICONS[status];
	return (
		<span className={`inline-flex flex-row items-center gap-1 ${className}`}>
			{IconComponent ? <IconComponent style={{ color }} /> : null}
			<span>{displayNames[status] || status}</span>
		</span>
	);
};
